import { BUSINESS_UNITS, FALABELLA_COOKIES, SODIMAC_COOKIES } from '.';

export const SHORT_BUSINESS_UNITS = {
  SO: 'SO',
  FA: 'FA',
};
export const HOME_IMPROVEMENT_SERVICE_BASE_URL = {
  [SHORT_BUSINESS_UNITS.SO]: {
    development: 'https://staging.sodimac.cl',
    staging: 'https://staging.sodimac.cl',
    beta: 'https://beta.sodimac.cl',
    production: 'https://www.sodimac.cl',
  },
  // TODO: Add SO urls
  [SHORT_BUSINESS_UNITS.FA]: {
    development: 'https://staging.falabella.com',
    staging: 'https://staging.falabella.com',
    beta: 'https://beta.falabella.com',
    production: 'https://www.falabella.com',
  },
};

export const defaultContentsToInclude = [
  'pages.journeys_page_introduction',
  'pages.journeys_page_timeline',
  'pages.journeys_page_measurement',
  'pages.journeys_page_product_details',
  'pages.journeys_page_addtocart',
];

export type Environments = 'development' | 'staging' | 'beta' | 'production';

export const IMAGE_HOSTS = {
  [SHORT_BUSINESS_UNITS.SO]: 'images.sodimac.com',
  [SHORT_BUSINESS_UNITS.FA]: 'images.falabella.com',
};

export const IMAGE_URLS = {
  CHEVRON_UP: {
    URL: 'https://images.sodimac.com/v3/assets/blt34d59f5b52e53f95/blt38a758dcb9b28761/Chevron-up.svg',
    ALT_TEXT: 'Chevron Up',
  },
  CLOSE_ICON: {
    URL: 'https://images.sodimac.com/v3/assets/blt34d59f5b52e53f95/bltdae2e12ec75cb6b3/cross-icon.svg',
    ALT_TEXT: 'Close Icon',
  },
  SUCCESS_ICON: {
    URL: 'https://images.sodimac.com/v3/assets/blt34d59f5b52e53f95/blt19c6f0b07446c315/succes.svg',
    ALT_TEXT: 'Success Icon',
  },
};

export const FETCH_SESSION_INFO_URL =
  'rest/model/falabella/rest/common/CommonActor/fetchSessionInfo';
export const ATG_CART_URL =
  'rest/model/atg/commerce/order/purchase/CartModifierActor/addItemToBasket';

export const CATALYST_CART_URL = 's/checkout/v1/carts';

const KEYS = {
  BASE_URL: 'BASE_URL',
};

export const ENVIRONMENTS = {
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  BETA: 'beta',
  PRODUCTION: 'production',
};

export const TENANT_NAMES = {
  SOMX: 'SOMX',
  SOCO: 'SOCO',
  SOAR: 'SOAR',
  SOPE: 'SOPE',
  SOCL: 'SOCL',
  SOUY: 'SOUY',
  SOBR: 'SOBR',
  FACL: 'FACL',
  FAPE: 'FAPE',
  FACO: 'FACO',
  SODIMAC_RETAIL: {
    SOMX: 'SODIMAC_RETAIL_SOMX',
  },
};

export const ATG_SITE_IDS = {
  [TENANT_NAMES.SOMX]: 'SMXStore',
  [TENANT_NAMES.SOCO]: 'SOCOStore',
  [TENANT_NAMES.SOAR]: 'SARStore',
  [TENANT_NAMES.SOPE]: 'SPEStore',
  [TENANT_NAMES.SOCL]: 'SCLStore',
  [TENANT_NAMES.SOUY]: 'SUYStore',
  [TENANT_NAMES.SOBR]: 'SBRStore',
};

export const TENANTS = {
  [TENANT_NAMES.SOCL]: {
    [ENVIRONMENTS.DEVELOPMENT]: {
      [KEYS.BASE_URL]: 'https://staging-sodimac.falabella.com',
    },
    [ENVIRONMENTS.STAGING]: {
      [KEYS.BASE_URL]: 'https://staging-sodimac.falabella.com',
    },
    [ENVIRONMENTS.BETA]: {
      [KEYS.BASE_URL]: 'https://beta-sodimac.falabella.com',
    },
    [ENVIRONMENTS.PRODUCTION]: {
      [KEYS.BASE_URL]: 'https://sodimac.falabella.com',
    },
  },
  [TENANT_NAMES.SOPE]: {
    [ENVIRONMENTS.DEVELOPMENT]: {
      [KEYS.BASE_URL]: 'https://staging-sodimac.falabella.com.pe',
    },
    [ENVIRONMENTS.STAGING]: {
      [KEYS.BASE_URL]: 'https://staging-sodimac.falabella.com.pe',
    },
    [ENVIRONMENTS.BETA]: {
      [KEYS.BASE_URL]: 'https://beta-sodimac.falabella.com.pe',
    },
    [ENVIRONMENTS.PRODUCTION]: {
      [KEYS.BASE_URL]: 'https://sodimac.falabella.com.pe',
    },
  },
  [TENANT_NAMES.SOCO]: {
    [ENVIRONMENTS.DEVELOPMENT]: {
      [KEYS.BASE_URL]: 'https://staging.homecenter.com.co',
    },
    [ENVIRONMENTS.STAGING]: {
      [KEYS.BASE_URL]: 'https://staging.homecenter.com.co',
    },
    [ENVIRONMENTS.BETA]: {
      [KEYS.BASE_URL]: 'https://beta.homecenter.com.co',
    },
    [ENVIRONMENTS.PRODUCTION]: {
      [KEYS.BASE_URL]: 'https://www.homecenter.com.co',
    },
  },
  [TENANT_NAMES.SOMX]: {
    [ENVIRONMENTS.DEVELOPMENT]: {
      [KEYS.BASE_URL]: 'https://staging.sodimac.com.mx',
    },
    [ENVIRONMENTS.STAGING]: {
      [KEYS.BASE_URL]: 'https://staging.sodimac.com.mx',
    },
    [ENVIRONMENTS.BETA]: {
      [KEYS.BASE_URL]: 'https://beta.sodimac.com.mx',
    },
    [ENVIRONMENTS.PRODUCTION]: {
      [KEYS.BASE_URL]: 'https://www.sodimac.com.mx',
    },
  },
  [TENANT_NAMES.SOBR]: {
    [ENVIRONMENTS.DEVELOPMENT]: {
      [KEYS.BASE_URL]: 'https://staging.sodimac.com.br',
    },
    [ENVIRONMENTS.STAGING]: {
      [KEYS.BASE_URL]: 'https://staging.sodimac.com.br',
    },
    [ENVIRONMENTS.BETA]: {
      [KEYS.BASE_URL]: 'https://beta.sodimac.com.br',
    },
    [ENVIRONMENTS.PRODUCTION]: {
      [KEYS.BASE_URL]: 'https://www.sodimac.com.br',
    },
  },
  [TENANT_NAMES.SOAR]: {
    [ENVIRONMENTS.DEVELOPMENT]: {
      [KEYS.BASE_URL]: 'https://staging.sodimac.com.ar',
    },
    [ENVIRONMENTS.STAGING]: {
      [KEYS.BASE_URL]: 'https://staging.sodimac.com.ar',
    },
    [ENVIRONMENTS.BETA]: {
      [KEYS.BASE_URL]: 'https://beta.sodimac.com.ar',
    },
    [ENVIRONMENTS.PRODUCTION]: {
      [KEYS.BASE_URL]: 'https://www.sodimac.com.ar',
    },
  },
  [TENANT_NAMES.SOUY]: {
    [ENVIRONMENTS.DEVELOPMENT]: {
      [KEYS.BASE_URL]: 'https://staging.sodimac.com.uy',
    },
    [ENVIRONMENTS.STAGING]: {
      [KEYS.BASE_URL]: 'https://staging.sodimac.com.uy',
    },
    [ENVIRONMENTS.BETA]: {
      [KEYS.BASE_URL]: 'https://beta.sodimac.com.uy',
    },
    [ENVIRONMENTS.PRODUCTION]: {
      [KEYS.BASE_URL]: 'https://www.sodimac.com.uy',
    },
  },
  [TENANT_NAMES.FACL]: {
    [ENVIRONMENTS.DEVELOPMENT]: {
      [KEYS.BASE_URL]: 'https://staging.falabella.com',
    },
    [ENVIRONMENTS.STAGING]: {
      [KEYS.BASE_URL]: 'https://staging.falabella.com',
    },
    [ENVIRONMENTS.BETA]: {
      [KEYS.BASE_URL]: 'https://beta.falabella.com',
    },
    [ENVIRONMENTS.PRODUCTION]: {
      [KEYS.BASE_URL]: 'https://www.falabella.com',
    },
  },
  [TENANT_NAMES.FAPE]: {
    [ENVIRONMENTS.DEVELOPMENT]: {
      [KEYS.BASE_URL]: 'https://staging.falabella.com.pe',
    },
    [ENVIRONMENTS.STAGING]: {
      [KEYS.BASE_URL]: 'https://staging.falabella.com.pe',
    },
    [ENVIRONMENTS.BETA]: {
      [KEYS.BASE_URL]: 'https://beta.falabella.com.pe',
    },
    [ENVIRONMENTS.PRODUCTION]: {
      [KEYS.BASE_URL]: 'https://www.falabella.com.pe',
    },
  },
  [TENANT_NAMES.FACO]: {
    [ENVIRONMENTS.DEVELOPMENT]: {
      [KEYS.BASE_URL]: 'https://staging.falabella.com.co',
    },
    [ENVIRONMENTS.STAGING]: {
      [KEYS.BASE_URL]: 'https://staging.falabella.com.co',
    },
    [ENVIRONMENTS.BETA]: {
      [KEYS.BASE_URL]: 'https://beta.falabella.com.co',
    },
    [ENVIRONMENTS.PRODUCTION]: {
      [KEYS.BASE_URL]: 'https://www.falabella.com.co',
    },
  },
};

export const PRODUCT_DETAILS_URL = 's/home-improvements/services/product';

export const PRODUCT_DETAILS_API_QUERY_PARAMS = {
  PRODUCT_ID: 'productId',
  VARIANT_ID: 'variantId',
  ZONES: 'zones',
  PGID: 'pgid',
  PID: 'pid',
  EXP: 'exp',
  STORE: 'store',
};

export const CONTENT_STACK_HOSTS = [
  'images.contentstack.io',
  'assets.contentstack.io',
];
export const CONTENT_STACK_IMAGE_HOST = 'images.contentstack.io';

export const DESKTOP_MAIN_IMAGE_PLACEHOLDER =
  'https://images.sodimac.com/v3/assets/blt6df9971ff924b699/blt3b79ed690d9eb3df/66fb9eae48be05c08c15babb/desktop_main_placeholder.png';
export const MOBILE_MAIN_IMAGE_PLACEHOLDER =
  'https://images.sodimac.com/v3/assets/blt6df9971ff924b699/bltd416a2b2384dbd36/66fb9eae7d4d2f05518b5c40/mobile_placeholder.png';
export const THUMBNAIL_PLACEHOLDER =
  'https://images.sodimac.com/v3/assets/blt6df9971ff924b699/bltc606c4a51d060516/66fb9eae504b4b809f982c3e/thumb-placeholder.png';

export const SELECTION_API_PATH = '/s/home-improvements/services/selection';

export const EXPERIENCE = Object.freeze({
  catalyst: 'catalyst',
  atg: 'atg',
});

export const TENANT_CROSS_CONFIG = Object.freeze({
  [TENANT_NAMES.FACL]: {
    experience: EXPERIENCE.catalyst,
    cartLineName: BUSINESS_UNITS.FALABELLA,
    commerce: 'FCM',
    ecommName: 'marketplace-cl',
    originName: 'PDP',
    originView: 'Product',
    siteName: 'default',
    quantityUnit: 'C/U',
    zoneCookieName: FALABELLA_COOKIES.ZONES,
    priceGroupCookieName: FALABELLA_COOKIES.PG_ID,
    cartIdCookieName: 'cartId',
    authSidCookieName: 'sid',
    authorization: 'Authorization',
  },
  [TENANT_NAMES.FAPE]: {
    experience: EXPERIENCE.catalyst,
    cartLineName: BUSINESS_UNITS.FALABELLA,
    commerce: 'FCM',
    ecommName: 'marketplace-pe',
    originName: 'PDP',
    originView: 'Product',
    siteName: 'default',
    quantityUnit: 'C/U',
    zoneCookieName: FALABELLA_COOKIES.ZONES,
    priceGroupCookieName: FALABELLA_COOKIES.PG_ID,
    cartIdCookieName: 'cartId',
    authSidCookieName: 'sid',
    authorization: 'Authorization',
  },
  [TENANT_NAMES.FACO]: {
    experience: EXPERIENCE.catalyst,
    cartLineName: BUSINESS_UNITS.FALABELLA,
    commerce: 'FCM',
    ecommName: 'marketplace-co',
    originName: 'PDP',
    originView: 'Product',
    siteName: 'default',
    quantityUnit: 'C/U',
    zoneCookieName: FALABELLA_COOKIES.ZONES,
    priceGroupCookieName: FALABELLA_COOKIES.PG_ID,
    cartIdCookieName: 'cartId',
    authSidCookieName: 'sid',
    authorization: 'Authorization',
  },
  [TENANT_NAMES.SOCL]: {
    experience: EXPERIENCE.catalyst,
    cartLineName: BUSINESS_UNITS.FALABELLA,
    commerce: 'FCM',
    ecommName: 'marketplacesodimac-cl',
    originName: 'PDP',
    originView: 'Product',
    siteName: 'sodimac',
    quantityUnit: 'C/U',
    zoneCookieName: FALABELLA_COOKIES.ZONES,
    priceGroupCookieName: FALABELLA_COOKIES.PG_ID,
    cartIdCookieName: 'cartId',
    authSidCookieName: 'sid',
    authorization: 'Authorization',
  },
  [TENANT_NAMES.SOPE]: {
    experience: EXPERIENCE.catalyst,
    cartLineName: BUSINESS_UNITS.FALABELLA,
    commerce: 'FCM',
    ecommName: 'marketplacesodimac-pe',
    originName: 'PDP',
    originView: 'Product',
    siteName: 'sodimac',
    quantityUnit: 'C/U',
    zoneCookieName: FALABELLA_COOKIES.ZONES,
    priceGroupCookieName: FALABELLA_COOKIES.PG_ID,
    cartIdCookieName: 'cartId',
    authSidCookieName: 'sid',
    authorization: 'Authorization',
  },
  [TENANT_NAMES.SOCO]: {
    experience: EXPERIENCE.catalyst,
    cartLineName: BUSINESS_UNITS.SODIMAC,
    ecommName: 'homecenter-co',
    quantityUnit: 'und',
    zoneCookieName: SODIMAC_COOKIES.ZONES,
    priceGroupCookieName: SODIMAC_COOKIES.PG_ID_CO,
    cartIdCookieName: 'cartId',
    authSidCookieName: 'sid',
    authorization: 'Sid',
  },
  [TENANT_NAMES.SOMX]: {
    experience: EXPERIENCE.atg,
    cartLineName: BUSINESS_UNITS.SODIMAC,
    zoneCookieName: SODIMAC_COOKIES.ZONES,
    priceGroupCookieName: SODIMAC_COOKIES.PG_ID,
  },
  [TENANT_NAMES.SOBR]: {
    experience: EXPERIENCE.catalyst,
    cartLineName: BUSINESS_UNITS.SODIMAC,
    ecommName: 'sodimac-br',
    quantityUnit: 'peç',
    zoneCookieName: SODIMAC_COOKIES.ZONES,
    priceGroupCookieName: SODIMAC_COOKIES.PG_ID,
    cartIdCookieName: 'cartId',
    authSidCookieName: 'sid',
    authorization: 'Sid',
  },
  [TENANT_NAMES.SOAR]: {
    experience: EXPERIENCE.atg,
    cartLineName: BUSINESS_UNITS.SODIMAC,
    zoneCookieName: SODIMAC_COOKIES.ZONES,
    priceGroupCookieName: SODIMAC_COOKIES.PG_ID,
  },
  [TENANT_NAMES.SOUY]: {
    experience: EXPERIENCE.atg,
    cartLineName: BUSINESS_UNITS.SODIMAC,
    zoneCookieName: SODIMAC_COOKIES.ZONES,
    priceGroupCookieName: SODIMAC_COOKIES.PG_ID,
  },
  [TENANT_NAMES.SODIMAC_RETAIL.SOMX]: {
    experience: EXPERIENCE.catalyst,
    cartLineName: BUSINESS_UNITS.FALABELLA,
    commerce: 'FCM',
    'x-ecomm-name': 'sodimac-mx',
    siteName: 'sodimac',
    zoneCookieName: FALABELLA_COOKIES.ZONES,
    priceGroupCookieName: FALABELLA_COOKIES.PG_ID,
    cartIdCookieName: 'cartId',
    authSidCookieName: 'sid',
    authorization: 'Authorization',
  },
});
